import { render, staticRenderFns } from "./PaymentMethodShow.vue?vue&type=template&id=b5336c18&scoped=true&"
import script from "./PaymentMethodShow.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5336c18",
  null
  
)

export default component.exports